export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"}],"link":[{"rel":"preconnect","href":"https://dcdn-jufair.jufair.com"},{"rel":"preconnect","href":"https://m-file.jufair.com"},{"rel":"preconnect","href":"http://qfck70.kuaishang.cn"},{"rel":"preconnect","href":"https://api.map.baidu.com"},{"rel":"preconnect","href":"https://hm.baidu.com"},{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"}],"style":[],"script":[{"innerHTML":"\n            if (!Array.prototype.at) {\n              Array.prototype.at = function(index) {\n                if (index < 0) {\n                  return this[this.length + index];\n                }\n                return this[index];\n              };\n            }\n          "}],"noscript":[],"title":"聚展网-展会网_国际展会_展会门票_展会信息服务平台"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/v3"

export const appCdnURL = "https://w3-file.jufair.com/prod/"

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"deep":false}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = true

export const purgeCachedData = false

export const granularCachedData = false

export const pendingWhenIdle = false

export const alwaysRunFetchOnKeyChange = false